import React, { FC } from "react";
import { useSelector } from "react-redux";
import TableTab from "../../../components/tabs/table-tab";
import { REPORTS_CARD_EXPIRY } from "../../../constants/menu-types";
import { useLocale } from "../../../contexts/localeContext";
import { TableContextProvider } from "../../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import ExpiredCredentialReportColumn from "../../../models/ColumnDefinitions/ExpiredCredentialReportColumn";
import { Lookup } from "../../../models/Lookup";
import CategorySearch from "../../../models/search/CategorySearch";
import ExpiredCredentialReportSearch from "../../../models/search/ExpiredCredentialReportSearch";
import { auditRunReport } from "../../../services/auditService";
import { getCategoryNameWithPagination } from "../../../services/categoryService";
import { getCompanyNamesWithPagination } from "../../../services/companyService";
import { getCredentialNameTypesWithPagination } from "../../../services/credentialsService";
import { getDepartmentNamesWithPagination } from "../../../services/departmentService";
import { getExpiredCredentialReports } from "../../../services/reportService";
import { getErrorMessage } from "../../../services/utilities/ServiceError";
import { IAppState } from "../../../store/types";

interface CardExpiryReportProps {
    reportId: string;
}

const CardExpiryReport: FC<CardExpiryReportProps> = ({ reportId }) => {
    const { translate } = useLocale();
    const user = useSelector((state: IAppState) => (state.userInfo));
    const lookup: Lookup[] = [
        {
            name: "departmentId",
            values: [],
            dataMethod: getDepartmentNamesWithPagination,
            searchAccessor: ExpiredCredentialReportColumn.find(column => column.accessor === "departmentName")?.searchOnName
        },
        {
            name: "companyId",
            values: [],
            dataMethod: getCompanyNamesWithPagination,
            searchAccessor: ExpiredCredentialReportColumn.find(column => column.accessor === "companyName")?.searchOnName
        },
        {
            name: "tagTypeId",
            values: [],
            dataMethod: getCredentialNameTypesWithPagination,
            searchAccessor: ExpiredCredentialReportColumn.find(column => column.accessor === "type")?.searchOnName
        },
        {
            name: "profileId",
            values: [],
            dataMethod: getCategoryNameWithPagination,
            searchAccessor: CategorySearch.find(item => item.accessor === "name")?.searchOnName
        }
    ];

    // user preference items
    const userLoginId = useSelector((state: any) => (state.userInfo.id))
    const currentMenuDetail = REPORTS_CARD_EXPIRY;
    const initialiseUserPreferences = (setDetails: (userLoginId, currentMenuDetail, [], reportId) => void) => {
        setDetails(userLoginId, currentMenuDetail, [], reportId);
    }
    // <-- end context

    const getDataMethod = async (listParameters?: any) => {
        try {
            await auditRunReport(reportId);
            return getExpiredCredentialReports(user.profileId, translate, listParameters);
        } catch (error) {
            return Promise.reject(getErrorMessage(error));
        }
    }

    return (<TableContextProvider
        dataMethod={getDataMethod}
        initialiser={(setDetails) => initialiseUserPreferences(setDetails)}
        tableDescriptor={ExpiredCredentialReportColumn}
        searchDescriptor={ExpiredCredentialReportSearch}
        useFilter
        useSort
        usePagination
        useSearch
        useTable
        lookup={lookup}>
        <TableTab
            title={''}
            reportTitle={translate.byKey(TranslationKeys.cardExpiry)}
            selectRows={false}
            cyName="cardExpiry">
        </TableTab>
    </TableContextProvider >
    );
};

export default CardExpiryReport;
